import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';

import Layout from './components/Layout';
import Home from './pages/Home';
import FindLawyer from './pages/FindLawyer';
import LegalGuides from './pages/LegalGuides';
import GuideDetail from './pages/GuideDetail';
import FreeAid from './pages/FreeAid';
import Track from './pages/Track';
import GetHelp from './pages/GetHelp';
import Shop from './pages/Shop';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import EnrollAdvocate from './pages/EnrollAdvocate';
import EnrollmentSuccess from './pages/EnrollmentSuccess';
import About from './pages/About';
import LawyerProfile from './pages/LawyerProfile';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/find-a-lawyer" element={<FindLawyer />} />
            <Route path="/legal-guides" element={<LegalGuides />} />
            <Route path="/legal-guides/:id" element={<GuideDetail />} />
            <Route path="/free-aid" element={<FreeAid />} />
            <Route path="/track" element={<Track />} />
            <Route path="/get-help" element={<GetHelp />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/checkout" element={<Checkout />} />
            <Route path="/shop/success/:orderId" element={<OrderSuccess />} />
            <Route path="/enroll-advocate" element={<EnrollAdvocate />} />
            <Route path="/enroll-advocate/success/:orderId" element={<EnrollmentSuccess />} />
            <Route path="/about" element={<About />} />
            <Route path="/lawyer/:id" element={<LawyerProfile />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
